/*
 * File: EmptyComponent.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 22, 2022 at 10:36 AM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 8, 2024 at 10:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

// Components
import { Typography } from '../Typography';

// Styles
import * as S from './EmptyComponent.styles';


/**
 * Component
 */

export const EmptyComponent = ({ title, message, icon }) => (
	<S.Wrapper>
		<FontAwesomeIcon className="empty-icon" icon={icon} size="5x" />
		<Typography tag="h4" weight="bold" center>
			{title}
		</Typography>
		<Typography tag="p" className="description" center>
			{message}
		</Typography>
	</S.Wrapper>
);


/**
 * Configuration
 */

EmptyComponent.displayName = 'EmptyComponent';
EmptyComponent.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	icon: PropTypes.arrayOf(PropTypes.string),
};
EmptyComponent.defaultProps = {
	icon: ['fal', 'hashtag']
};
